import React from 'react';
import { Link } from 'react-router-dom';

function SuccessPage(){
    return(
        <div className="mt-5">
            <h1>Din forespørsel er sendt!</h1>
            <h2 className="mt-5"> Trykk <Link to="/home">her</Link> for å gå tilbake!</h2>
        </div>
    )
}

export default SuccessPage;